import { ReactElement, useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RfUiInput, RfUiButton, CdkHeader } from 'renfe-components';
import { useHistory } from 'react-router-dom';
import { setUsernamePassword } from 'store/app/actions';
import {
  makeSelectGetTokenRequestStatusIsLoading,
  makeSelectGetTokenRequestStatus,
  makeSelectTokenAccessToken,
  makeSelectForbiddenAccess,
} from 'store/oauth/selectors';
import { createStructuredSelector } from 'reselect';
import { RequestStatusTypes, RouteTypes, TxtTypes } from 'consts';
import { language } from 'utils/literals';
import { ErrorMessage } from 'components/ErrorMessage/ErrorMessage';
import { setForbiddenAccess } from 'store/oauth/actions';
import { getPerfilesUsuarioRequest } from 'store/usuarios/actions';
import {
  makeSelectPerfilesUsuario,
  makeSelectPerfilesUsuarioDatosPerfilesUsuario,
} from 'store/usuarios/selectors';
import { checkProfilesWithURL } from 'containers/Header';
import { APP_HEADER_PAGETITLE } from 'variables';

const selectors = createStructuredSelector({
  getTokenRequestStatusIsLoading: makeSelectGetTokenRequestStatusIsLoading(),
  datosPerfilesUsuario: makeSelectPerfilesUsuarioDatosPerfilesUsuario(),
  perfilesUsuario: makeSelectPerfilesUsuario(),
  getTokenRequestStatus: makeSelectGetTokenRequestStatus(),
  access_token: makeSelectTokenAccessToken(),
  forbiddenAccess: makeSelectForbiddenAccess(),
} as any);

const LoginForm = (): ReactElement => {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    getTokenRequestStatusIsLoading,
    getTokenRequestStatus,
    access_token,
    perfilesUsuario,
    forbiddenAccess,
  } = useSelector<any, any>(selectors);
  const [usernameInputValue, setUsernameInputValue] = useState('');
  const [passwordInputValue, setPasswordInputValue] = useState('');

  const handleOnChangeUsername = (e: any) => {
    const value = e?.detail.trim() || '';
    setUsernameInputValue(value);
  };

  const handleOnChangePassword = (e: any) => {
    const value = e?.detail || '';
    setPasswordInputValue(value);
  };

  const handleIsDisabled = useCallback(
    (): boolean =>
      Boolean(
        usernameInputValue === '' ||
          passwordInputValue === '' ||
          getTokenRequestStatusIsLoading
      ),
    [usernameInputValue, passwordInputValue, getTokenRequestStatusIsLoading]
  );

  const handleOnSubmit = useCallback(() => {
    if (!handleIsDisabled()) {
      dispatch(
        setUsernamePassword({
          username: usernameInputValue.toUpperCase(),
          password: passwordInputValue,
        })
      );
    }
  }, [handleIsDisabled, dispatch, usernameInputValue, passwordInputValue]);

  const handleOnSubmitForm = (e) => {
    e.preventDefault();
    handleOnSubmit();
  };

  useEffect(() => {
    if (access_token) {
      dispatch(getPerfilesUsuarioRequest());
    }
  }, [access_token, dispatch]);

  useEffect(() => {
    const datosPerfilesUsuario = perfilesUsuario.DATOS_PERFILES_USUARIO;
    const perfiles = perfilesUsuario.PERFILES;

    if (!datosPerfilesUsuario.length && !perfiles.length) {
      return;
    }
    const noProfiles = !datosPerfilesUsuario.length;
    const numberOfPerfilCondition = false;
    const urlCondition = !checkProfilesWithURL(datosPerfilesUsuario);

    if (noProfiles || numberOfPerfilCondition || urlCondition) {
      dispatch(setForbiddenAccess(TxtTypes.TXT_LOGIN_FORBIDDEN_ACCESS));
    } else {
      history.push(RouteTypes.HOME);
    }
  }, [perfilesUsuario]);

  return (
    <div className="rf-container">
      <CdkHeader
        headerText={APP_HEADER_PAGETITLE}
        headerTextMobile="GFM"
      ></CdkHeader>

      <nav className="rf-navigation"></nav>

      <form className="rf-login" onSubmit={handleOnSubmitForm}>
        <fieldset className="rf-login__fieldset">
          <legend className="rf-login__title">
            {language.login.accesoLabel}
          </legend>

          <div className="rf-input-container">
            <RfUiInput
              label={language.login.userLabel}
              error=""
              name="user"
              autocomplete="username"
              value={usernameInputValue}
              placeholder={language.login.userPlaceholder}
              onValueChanges={handleOnChangeUsername}
              inputEmitActive={true}
            ></RfUiInput>
          </div>

          <div className="rf-input-container">
            <RfUiInput
              label={language.login.passLabel}
              error=""
              name="password"
              typeInput="password"
              autocomplete="current-password"
              value={passwordInputValue}
              placeholder={language.login.passPlaceholder}
              onValueChanges={handleOnChangePassword}
              inputEmitActive={true}
            ></RfUiInput>
          </div>

          {getTokenRequestStatus.status === RequestStatusTypes.Error ? (
            <ErrorMessage
              message={getTokenRequestStatus.message}
            ></ErrorMessage>
          ) : (
            <ErrorMessage message={forbiddenAccess}></ErrorMessage>
          )}
        </fieldset>

        <div className="rf-login__box">
          {/* <RfUiLink
            link="forgot-password"
            text="He olvidado mi contraseña"
            text-help="He olvidado mi contraseña"
          >
          </RfUiLink> */}
          <RfUiButton
            className="rf-ui-button--width-100"
            text={language.login.accederLabel}
            aspect="primary"
            disabled={handleIsDisabled()}
            onClick={handleOnSubmit}
            type="submit"
          ></RfUiButton>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;
